import styled from 'styled-components/macro';

import Typography from 'components/Typography/Typography';

export const TooltipWrapStyled = styled.div`
  width: 300px;
  padding: 0.75rem;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: ${({ theme }) => theme.radius.sm};

  ${({ theme }) => `
    ${theme.devices.tablet} {
      width: 320px;
    }
  `}

  img {
    width: 100%;
  }
`;

export const StepContentStyled = styled(Typography)`
  margin: 1.25rem 0;
`;
